const REFERRER_KEY = 'login_referrer';
const DEFAULT_REDIRECT = '/profile/company';

const EXCLUDED_PATHS = ['/auth/', '/privacy', '/terms', '/restore', '/registration/employee'];

export function saveLoginReferrer(url?: string): void {
  const currentUrl = url || window.location.pathname + window.location.search;

  // Don't save auth-related or modal paths as referrer
  if (EXCLUDED_PATHS.some(path => currentUrl.startsWith(path))) {
    return;
  }

  // Don't save external URLs (security)
  if (currentUrl.startsWith('http://') || currentUrl.startsWith('https://')) {
    return;
  }

  sessionStorage.setItem(REFERRER_KEY, currentUrl);
}

export function getLoginReferrer(): string {
  return sessionStorage.getItem(REFERRER_KEY) || DEFAULT_REDIRECT;
}

export function clearLoginReferrer(): void {
  sessionStorage.removeItem(REFERRER_KEY);
}
